module.exports = __webpack_public_path__ + "static/media/farm-large.e8bf2c9d.png";